import type { MouseEvent } from 'react';
import { buildConversationPath } from '@/entities/conversations';
import { preventShiftSelection } from '@/shared/lib';

/** Пропсы ссылки на диалог: адрес и перехват нажатия. Оформление задаёт сама строка. */
type ConversationLinkProps = {
  href: string;
  onMouseDown: (event: MouseEvent) => void;
  onClick: (event: MouseEvent<HTMLAnchorElement>) => void;
};

/**
 * Собирает строку дашборда, ведущую в диалог: адрес видно и можно скопировать, но переход
 * выполняем сами — по shift браузер открыл бы окно, а не вкладку.
 *
 * Отдаёт пропсы, а не готовую строку: строки, ведущие в диалог, у блоков дашборда разные
 * (карточка топ-звонка — консультант с баллом, строка списка диалогов — название с величиной),
 * общее у них только правило перехода. Функция, а не хук: список диалогов собирает такие
 * строки в цикле.
 */
export const getConversationLinkProps = (
  conversationId: number,
  onOpen: (conversationId: number, openInNewTab: boolean) => void,
): ConversationLinkProps => ({
  href: buildConversationPath(conversationId),
  onMouseDown: preventShiftSelection,
  onClick: (event) => {
    event.preventDefault();
    onOpen(conversationId, event.shiftKey);
  },
});
